/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationRun } from './AutomationRun';
import {
    AutomationRunFromJSON,
    AutomationRunFromJSONTyped,
    AutomationRunToJSON,
    AutomationRunToJSONTyped,
} from './AutomationRun';

/**
 * 
 * @export
 * @interface ListAutomationRunsResponse
 */
export interface ListAutomationRunsResponse {
    /**
     * 
     * @type {Array<AutomationRun>}
     * @memberof ListAutomationRunsResponse
     */
    runs: Array<AutomationRun>;
}

/**
 * Check if a given object implements the ListAutomationRunsResponse interface.
 */
export function instanceOfListAutomationRunsResponse(value: object): value is ListAutomationRunsResponse {
    if (!('runs' in value) || value['runs'] === undefined) return false;
    return true;
}

export function ListAutomationRunsResponseFromJSON(json: any): ListAutomationRunsResponse {
    return ListAutomationRunsResponseFromJSONTyped(json, false);
}

export function ListAutomationRunsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAutomationRunsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'runs': ((json['runs'] as Array<any>).map(AutomationRunFromJSON)),
    };
}

export function ListAutomationRunsResponseToJSON(json: any): ListAutomationRunsResponse {
    return ListAutomationRunsResponseToJSONTyped(json, false);
}

export function ListAutomationRunsResponseToJSONTyped(value?: ListAutomationRunsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'runs': ((value['runs'] as Array<any>).map(AutomationRunToJSON)),
    };
}

